module.exports = __webpack_public_path__ + "static/img/icon_hze.66100cb9.png";